import React, { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Icon } from '../../components/Icon';
import { useAuth } from '../../hooks/auth';
import { useModal } from '../../hooks/modal';
import { useToast } from '../../hooks/toast';
import { api } from '../../services/api';
import { colors } from '../../styles/tokens';

import {
  Button,
  Cancel,
  ConfirmInput,
  Container,
  Content,
  FooterRow,
  IconCircle,
  IconRow,
  Text,
  Title,
} from './styles';

const CONFIRM_WORD = 'APAGAR';

const DeleteAccount: React.FC = () => {
  const { removeModal, removeAllModals } = useModal();
  const { addToast } = useToast();
  const { signOut } = useAuth();
  const navigate = useNavigate();

  const [confirmText, setConfirmText] = useState('');

  const handleSubmit = useCallback(() => {
    api
      .delete(`users`)
      .then(() => {
        signOut();
        navigate('/');
        removeAllModals();
      })
      .catch(err =>
        addToast({
          title: `Erro cod: ${err?.response?.status}`,
          description:
            'Erro ao deletar a sua conta, entre em contato com o gertor do sistema.',
        }),
      );
  }, [addToast, navigate, removeAllModals, signOut]);

  return (
    <Container>
      <Content>
        <IconRow>
          <IconCircle>
            <Icon name="warning" size={24} color={colors.error} />
          </IconCircle>
          <Title>Apagar conta</Title>
        </IconRow>

        <Text>
          Esta ação é <span>permanente</span> e não pode ser desfeita. Todos os
          seus dados de acesso serão removidos.
        </Text>
        <Text>
          Para confirmar, digite <span className="danger">{CONFIRM_WORD}</span>{' '}
          abaixo.
        </Text>

        <ConfirmInput
          placeholder={CONFIRM_WORD}
          value={confirmText}
          onChange={e => setConfirmText(e.target.value)}
        />

        <FooterRow>
          <Cancel type="button" onClick={() => removeModal()}>
            Cancelar
          </Cancel>
          <Button
            name="deleteAcount"
            value="Apagar definitivamente"
            disabled={confirmText.trim().toUpperCase() !== CONFIRM_WORD}
            onClick={() => handleSubmit()}
          />
        </FooterRow>
      </Content>
    </Container>
  );
};

export { DeleteAccount };
